import { Component, forwardRef, Inject } from "@angular/core";
import { MatButtonToggleChange } from "@angular/material/button-toggle";
import { AuthenticationService } from "../../../service/authentication.service";
import { ActionExecutionTableColumn } from "../custom-table-column/action-execution-table-column";
import { ClickableTableValueComponent } from "./clickable-table-value.component";

@Component({
    selector: 'action-execution-table-value',
    template: `
        <mat-button-toggle-group #group="matButtonToggleGroup" *ngIf="isVisible()" [value]="[getValue()]" (change)="toggleChange($event)" multiple [disabled]="column.disabled || !canManage()">
            <mat-button-toggle value="DONE" class="execution-done" (click)="$event.stopPropagation()" 
                [matTooltip]="group.value.includes('DONE') ? 'Deselect': 'Mark as done' | localize" [matTooltipDisabled]="column.disabled">
                <mat-icon class="material-symbols-outlined">check</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="DONE_WITH_ISSUE" class="execution-done-with-issue" (click)="$event.stopPropagation()" 
                [matTooltip]="group.value.includes('DONE_WITH_ISSUE') ? 'Deselect' :  'Mark as done with issue' | localize" [matTooltipDisabled]="column.disabled">
                <mat-icon class="material-symbols-outlined">emergency_home</mat-icon>
            </mat-button-toggle>
            <mat-button-toggle value="DISCARDED" class="execution-discarded" (click)="$event.stopPropagation()"  
                [matTooltip]="group.value.includes('DISCARDED') ? 'Deselect' : 'Mark as discarded' | localize" [matTooltipDisabled]="column.disabled">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </mat-button-toggle>
         </mat-button-toggle-group> 
    `,
    styles: [`
        mat-button-toggle-group {
            padding: 2px;
            background-color: white !important;
        }
        mat-button-toggle {
            padding: 2px;
            border-left: none !important;
        }
        mat-button-toggle.mat-button-toggle-checked:not(.mat-button-toggle-disabled) {
            background-color: white;
            color: #212121;
        }
        mat-button-toggle ::ng-deep .mat-button-toggle-label-content {
            padding: 4px 8px;
            line-height: 24px !important;
            border-radius: 2px;
        }
        mat-button-toggle:hover ::ng-deep .mat-button-toggle-focus-overlay {
            background-color: transparent;
        }
        mat-button-toggle:not(.mat-button-toggle-checked):not(.mat-button-toggle-disabled) ::ng-deep .mat-button-toggle-label-content:hover {
            background-color:#2121211F;
        }
        mat-button-toggle.mat-button-toggle-checked.execution-done ::ng-deep .mat-button-toggle-label-content {
            background-color: #00C86526;
        }
        mat-button-toggle.mat-button-toggle-checked.execution-done ::ng-deep .mat-button-toggle-label-content:hover {
            background-color: #10784540;
        }
        mat-button-toggle.mat-button-toggle-checked.execution-done-with-issue ::ng-deep .mat-button-toggle-label-content {
            background-color: #F57C0026;
        }
        mat-button-toggle.mat-button-toggle-checked.execution-done-with-issue ::ng-deep .mat-button-toggle-label-content:hover {
            background-color: #90511040;
        }
        mat-button-toggle.mat-button-toggle-checked.execution-discarded ::ng-deep .mat-button-toggle-label-content {
            background-color: #DF231626;
        }
        mat-button-toggle.mat-button-toggle-checked.execution-discarded ::ng-deep .mat-button-toggle-label-content:hover {
            background-color: #85221b40;
        }
    `]
})
export class ActionExecutionTableValueComponent extends ClickableTableValueComponent<ActionExecutionTableColumn> {

    constructor(@Inject(forwardRef(() => AuthenticationService)) protected authenticationService: AuthenticationService) { super(null) }

    getValue(): any {
        return this.element[this.column.path];
    }

    toggleChange($event: MatButtonToggleChange) {
        const toggle = $event.source;
        const selected = !!toggle && $event.value.some(item => item == toggle.value);
        if (toggle) {
            toggle.buttonToggleGroup.value = selected ? [toggle.value] : [];
        }
        this.buttonAction.emit({ action: 'updateExecutionState', value: selected ? toggle.value : null, index: this.rowIndex });
    }

    canManage(): boolean {
        const actionDef = this.element.actionDefinition;
        if (!actionDef) {
            return true;
        }
        if (!actionDef.userTypeFiltered) {
            return true;
        }
        const userTypeId = this.authenticationService.getUser().userTypeId;
        return actionDef.writeUserTypeIds?.includes(userTypeId);
    }

}